<template>
  <div id="report">
    <div
      id="workerBarDiv"
      ref="workerBarDiv"
      style="width:100%;height:400px;margin-top:20px;"
      v-if="flag == 0"
    >

    </div>
  </div>
</template>


<script>
export default {
  name: "report",
  data() {
    return {
      workerBar: null,
      workerCircle: null,
      flag : 0,
      workerData:null
    };
  },
  mounted: function(){
    this.init();
  },
  methods:{
    init:function(){
      this.$RequestUtil.get({
          url: '/api/report/listWorkerProcessCount',
          params: {
          },
          success: (res) => {
              if(res.code == 0){
                this.workerData = res.data;
                this.showReport();
              }
          }
      });
    },
    showReport:function(){
      this.workerBar = this.$Echarts.init(this.$refs["workerBarDiv"]);
      let workerName = [];
      let qualifiedProcessCount = []; 
      this.workerData.forEach((val,index) => {
        workerName.push(val.workerName);
        qualifiedProcessCount.push(val.qualifiedProcessCount);
      });
      var option = {
        title: {
          text: "员工绩效统计分析"
        },
        color: ["#3398DB", "#536941"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: workerName,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "合格计件加工数总和(个)",
            type: "bar",
            barWidth: "60px",
            data: qualifiedProcessCount
          }/* ,
          {
            name: "设备有效运转时间总和(分钟)",
            type: "bar",
            barWidth: "60px",
            data: [3793, 2152, 6840, 3890, 4520, 542, 5888],
            barGap: "0"
          } */
        ]
      };
      this.workerBar.setOption(option);
      }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Report.vue